import { render, staticRenderFns } from "./JoaEmployeeLeaveListBiz.vue?vue&type=template&id=6fa62fa0&scoped=true&"
import script from "./JoaEmployeeLeaveListBiz.vue?vue&type=script&lang=js&"
export * from "./JoaEmployeeLeaveListBiz.vue?vue&type=script&lang=js&"
import style0 from "./JoaEmployeeLeaveListBiz.vue?vue&type=style&index=0&id=6fa62fa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa62fa0",
  null
  
)

export default component.exports